import template from './routeSheet.html';
import controller from './routeSheet.controller';
import './routeSheet.scss';

let routeSheetComponent = {
  restrict: 'E',
  bindings: {
    printData: '='
  },
  template,
  controller
};

export default routeSheetComponent;

     


// WEBPACK FOOTER //
// ./client/app/components/routeSheet/routeSheet.component.js